import * as Sentry from "@sentry/browser";
import posthog from "posthog-js";

export function PostHogIntegration() {
  return {
    name: "PostHogIntegration",

    setupOnce() {
      Sentry.addEventProcessor((event) => {
        const distinctId = posthog.get_distinct_id?.();
        if (distinctId) {
          event.user = event.user || {};
          event.user.id = distinctId;
        }

        return event;
      });
    },
  };
}
